import React from 'react';
import About from '../About/About';
import Contact from '../Contact/Contact';
import Footer from '../Footer/Footer';
import Navbar from '../Navbar/Navbar';
import Portfolio from '../Portfolio/Portfolio';
import Service from '../Service/Service';
import './Home.css'
const Home = () => {
    return (
        <div>
            <Navbar/>
            {/* home page header section */}
            <div id="header">
                <div className="header-text">
                    <p>UI/UX Designer</p>
                    <h1>Hi, I'm <span>Yeasin</span> founder of <br /><strong><span>Code</span> Box</strong></h1>
                </div>
            </div>

            {/* About Section */}
            <div id="about">
                <About></About>
            </div>

            {/* Service Section */}
            <div id="service">
                <Service></Service>
            </div>

            {/* Portfolio Section */}
            <div id="portfolio">
                <Portfolio></Portfolio>
            </div>

            {/* Portfolio Section */}
            <div id="contact">
                <Contact></Contact>
            </div>

            {/* Footer Section */}
            <div id="footer">
                <Footer></Footer>
            </div>
        </div>
    );
};

export default Home;